export default class Enum {
    static get FE_HTTP_METHOD() {
        return {
            GET: "GET",
            POST: "POST",
        }
    };

    static get FE_TOKEN_TYPE() {
        return {
            APP: "APP",
            EVALUATOR: "EVALUATOR",
            EVALUATEE: "EVALUATEE"
        }
    };


    static get SSE_TOPIC() {
        return {
            EVALUATION: "EVALUATION",
            EVALUATOR: "EVALUATOR",
            EVALUATEE: "EVALUATEE"
        }
    };

    // xxx.
    static get STATE_BASE() {
        return {
            ENABLE: true,
            DISABLE: false,
        }
    };

    static get GENDER() {
        return {
            MALE: "MALE",
            FEMALE: "FEMALE",
        }
    };

    static get USER_ROLE() {
        return {
            "SYSTEM_ADMINISTRATOR": "SYSTEM_ADMINISTRATOR",
            "ADMINISTRATOR": "ADMINISTRATOR",
            "USER": "USER"
        };
    };

    static get MEMBER_ROLE() {
        return {
            "WORKSPACE_ADMINISTRATOR": "WORKSPACE_ADMINISTRATOR",
            "ADMIN": "ADMINISTRATOR",
            "USER": "MEMBER"
        };
    };

    static get MEMBER_STATE() {
        return {
            "ACTIVE": "ACTIVE",
            "INACTIVE": "INACTIVE",
            "WITHDRAWAL": "WITHDRAWAL"
        };
    };

    static get PARTICIPANT_ROLE() {
        return {
            "NONE": "NONE",
            "EVALUATEE": "EVALUATEE",
            "EVALUATOR": "EVALUATOR",
            "EVALUATOR_LEADER": "EVALUATOR_LEADER"
        };
    };

    static get PARTICIPANT_CHANNEL() {
        return {
            "ACTIVE": "ACTIVE",         // 참석
            "PAPER": "PAPER",           // 서면
            "VIDEO": "VIDEO",           // 화상
            "ABSENCE": "ABSENCE",       // 불참
            "DELEGATE": "DELEGATE",     // 대리
        };
    };


    static get EVALUATION_DOCUMENT_TYPE() {
        return {
            "COMMON": "COMMON",                         // 개요
            "SIGNATURE_BOOK": "SIGNATURE_BOOK",         // 서명록

            "AGREEMENT": "AGREEMENT",                   // 동의서
            "QUESTION": "QUESTION",                     // 질문지
            "SURVEY": "SURVEY",                         // 설문지
            "EVALUATION": "EVALUATION",                 // 평가위원 서식
            "EVALUATOR_LEADER": "EVALUATOR_LEADER",     // 평가위원장 서식

            "GATHERING": "GATHERING",                   // 취합지
            "RESULT": "RESULT",                         // 결과서
        }
    };


    static get EVALUATOR_TYPE() {
        return {
            NONE: "NONE",
            INTERNAL: "INTERNAL",
            EXTERNAL: "EXTERNAL",
        }
    };

    static get EVALUATOR_ROLE() {
        return {
            ALL: "ALL",
            EVALUATOR: "EVALUATOR",
            EVALUATOR_LEADER: "EVALUATOR_LEADER"
        }
    };


    static get EVALUATION_CATEGORY_REFERENCE_TYPE() {
        return {
            "EVALUATION_DOCUMENT": "EVALUATION_DOCUMENT",   // 평가 문서
            "EVALUATOR": "EVALUATOR",                       // 평가자
        }
    };


    static get EVALUATION_OUTPUT_TYPE() {
        return {
            "PDF": "PDF",
            "ARCHIVE": "ARCHIVE",
        }
    };

    static get EVALUATION_TEMPLATE_STATUS() {
        return {
            "NONE": "NONE",
            "DELETE": "DELETE",
        }
    };


    // cat. evaluation
    static get EVALUATION_STEP() {
        return {
            "NONE": "NONE",
            "WAIT": "WAIT",                 // 안내
            "OPEN": "OPEN",                 // 안내
            "GATHERING": "GATHERING",       // 평가
            "RESULT": "RESULT",             // 취합
        }
    };

    static get EVALUATION_STATUS() {
        return {
            WAIT: "WAIT",
            READY: "READY",
            OPEN: "OPEN",
            CLOSE: "CLOSE",
        }
    };

    static get EVALUATION_GATHERING_STATUS() {
        return {
            NONE: "NONE",
            WAIT: "WAIT",               // 변환 대기
            READY: "READY",             // 변환 준비
            PROGRESS: "PROGRESS",       // 변환 진행
            FAILURE: "FAILURE",         // 변환 실패
            COMPLETE: "COMPLETE",       // 변환 완료
        }
    };

    static get EVALUATION_CONVERT_STATUS() {
        return {
            NONE: "NONE",
            WAIT: "WAIT",               // 변환 대기
            READY: "READY",             // 변환 준비
            PROGRESS: "PROGRESS",       // 변환 진행
            FAILURE: "FAILURE",         // 변환 실패
            COMPLETE: "COMPLETE",       // 변환 완료
        }
    };
}